import { inject, NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { ClashDefinitionComponent } from '@modules/competition/step-parameterization/clash-definition/clash-definition.component';
import { DownloadsComponent } from '@modules/downloads/downloads.component';
import { GeneralGuard } from './core/shared/guard/general-guard.service';

const routes: Routes = [
  {
    path: 'dashboard',
    canActivate: [() => inject(GeneralGuard).isAuthenticated()],
    loadChildren: () =>
      import('./core/modules/dashboards/dashboards.module').then(
        (mod) => mod.DashboardsModule
      ),
  },
  {
    path: 'login',
    canActivate: [() => inject(GeneralGuard).ifAuthenticatedBlock()],
    loadChildren: () =>
      import('./core/modules/login/login.module').then(
        (mod) => mod.LoginModule
      ),
  },
  {
    path: 'eventos',
    canActivate: [() => inject(GeneralGuard).isAuthenticated()],
    loadChildren: () =>
      import('./core/modules/events/events.module').then(
        (mod) => mod.EventsModule
      ),
  },

  {
    path: 'federacoes',
    canActivate: [() => inject(GeneralGuard).isCbdeAdmin()],
    loadChildren: () =>
      import('./core/modules/federation/federation.module').then(
        (mod) => mod.FederationModule
      ),
  },
  {
    path: 'competicoes',
    canActivate: [() => inject(GeneralGuard).isAuthenticated()],
    loadChildren: () =>
      import('./core/modules/championship/championship.module').then(
        (mod) => mod.ChampionshipModule
      ),
  },
  {
    path: 'inscricoes',
    canActivate: [() => inject(GeneralGuard).isAuthenticated()],
    loadChildren: () =>
      import('./core/modules/enrollments/enrollments.module').then(
        (mod) => mod.EnrollmentsModule
      ),
  },
  {
    path: 'perfil',
    canActivate: [() => inject(GeneralGuard).isAuthenticated()],
    loadChildren: () =>
      import('./core/modules/profile/profile.module').then(
        (mod) => mod.ProfileModule
      ),
  },
  {
    path: 'usuarios',
    canActivate: [() => inject(GeneralGuard).isAuthenticated()],
    loadChildren: () =>
      import('./core/modules/user/user.module').then((mod) => mod.UserModule),
  },

  {
    path:'estados',
    canActivate: [() => inject(GeneralGuard).isAuthenticated()],
    loadChildren: () => 
      import('./core/modules/states/states.module').then((mod) => mod.StatesModule)
  },
    {
    path:'cidades',
    canActivate: [() => inject(GeneralGuard).isAuthenticated()],
    loadChildren: () => 
      import('./core/modules/cities/cities.module').then((mod) => mod.CitiesModule)
  },
  {
    path: 'instituicoes',
    canActivate: [() => inject(GeneralGuard).isAuthenticated()],
    loadChildren: () =>
      import(
        './core/modules/teaching-institution/teaching-institution.module'
      ).then((mod) => mod.TeachingInstitutionModule),
  },
  {
    path: 'funcoes',
    canActivate: [() => inject(GeneralGuard).isCbdeAdmin()],
    loadChildren: () =>
      import('./core/modules/functions/functions.module').then(
        (mod) => mod.FunctionsModule
      ),
  },
  {
    path: 'competicoes',
    canActivate: [() => inject(GeneralGuard).isAuthenticated],
    loadChildren: () =>
      import('./core/modules/championship/championship.module').then(
        (mod) => mod.ChampionshipModule
      ),
  },
  {
    path: 'sorteios',
    canActivate: [() => inject(GeneralGuard).isAuthenticated],
    loadChildren: () =>
      import('./core/modules/draw/draw.module').then((mod) => mod.DrawModule),
  },
  {
    path: 'definicao-embates',
    canActivate: [() => inject(GeneralGuard).isAuthenticated],
    component: ClashDefinitionComponent,
  },
  {
    path: 'arenas',
    canActivate: [() => inject(GeneralGuard).isAuthenticated],
    loadChildren: () =>
      import('./core/modules/arena/arena.module').then(
        (mod) => mod.ArenaModule
      ),
  },
  {
    path: 'parametrizacao-etapa',
    canActivate: [() => inject(GeneralGuard).isAuthenticated],
    loadChildren: () =>
      import(
        './core/modules/competition/step-parameterization/step-parameterization.module'
      ).then((mod) => mod.StepParameterizationModule),
  },
  {
    path: 'parametrizacao-esporte',
    canActivate: [() => inject(GeneralGuard).isAuthenticated],
    loadChildren: () =>
      import(
        './core/modules/competition/sport-parameterization/sport-parameterization.module'
      ).then((mod) => mod.SportParameterizationModule),
  },
  {
    path: 'modelos-parametrizacao',
    canActivate: [() => inject(GeneralGuard).isAuthenticated],
    loadChildren: () =>
      import(
        './core/modules/competition/model-parameterization/model-parameterization.module'
      ).then((mod) => mod.ModelParameterizationModule),
  },
  {
    path: 'tabela-jogos',
    canActivate: [() => inject(GeneralGuard).isAuthenticated],
    loadChildren: () =>
      import(
        './core/modules/competition/games-table/games-table.module'
      ).then((mod) => mod.GamesTableModule),
  },
  {
    path: 'beneficios',
    canActivate: [() => inject(GeneralGuard).isAuthenticated],
    loadChildren: () =>
      import('./core/modules/benefits/benefit.module').then(
        (mod) => mod.BenefitModule
      ),
  },
  {
    path: 'servicos',
    canActivate: [() => inject(GeneralGuard).isAuthenticated],
    loadChildren: () =>
      import('./core/modules/services/services.module').then(
        (mod) => mod.ServicesModule
      ),
  },
  {
    path: 'registros',
    canActivate: [() => inject(GeneralGuard).isAuthenticated],
    loadChildren: () =>
      import('./core/modules/records/records.module').then(
        (mod) => mod.RecordsModule
      ),
  },
  {
    path: 'exportacoes',
    canActivate: [() => inject(GeneralGuard).isCbdeAdmin],
    loadChildren: () =>
      import('./core/modules/reports/reports.module').then(
        (mod) => mod.ReportsModule
      ),
  },
  {
    path: 'downloads',
    canActivate: [() => inject(GeneralGuard).isAuthenticated],
    component: DownloadsComponent,
  },
  {
    path: 'app',
    canActivate: [],
    loadChildren: () =>
      import('./core/external/external.module').then(
        (mod) => mod.ExternalModule
      ),
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/usuarios',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      bindToComponentInputs: true,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
